import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { addNote, removeNote, retrieveNotes, updateNote } from '../state';
import useNeuroState, {useDispatch} from '../../state';
import { getMessages } from '../../utils';
import { Notes } from '../../../neuro-ui';

const GuideNotes = ({ className }) => {
  const dispatch = useDispatch();
  const { conversationNotes = {}, user = {} } = useNeuroState();
  const { notes, isLoading } = conversationNotes;
  const currentEmployee = user?.assignment?.employee;
  const [localNotes, setLocalNotes] = useState(notes || []);
  const intl = useIntl();
  const messages = getMessages(intl.locale);

  useEffect(() => dispatch(retrieveNotes()), [dispatch]);
  useEffect(() => {
    const notesToKeep = (localNotes || []).filter((n) => n.isNew);
    const notesToSet = [...(notes || []), ...notesToKeep];
    setLocalNotes(notesToSet);
  }, [notes]);

  const onSave = ({ note, isNew, updatedNotes }) => {
    if (isNew) {
      dispatch(addNote(note));
    } else {
      dispatch(updateNote(note));
    }
    setLocalNotes(updatedNotes);
  };

  const onRemove = ({ note }) => {
    dispatch(removeNote(note));
  };

  return (
    <Notes
      className={className}
      currentEmployee={currentEmployee}
      isLoading={isLoading}
      messages={messages}
      notes={localNotes}
      onSave={onSave}
      onRemove={onRemove}
    />
  );
};

GuideNotes.propTypes = {
  className: PropTypes.string,
};

export default GuideNotes;
